import { get } from "@assets/js/imaios-global/imaios-global";
import { applyStructurePreview } from "../../../structure-preview/structure-preview";

initializeLanguageSwitcher();

export function initializeLanguageSwitcher() {
  document
    .getElementById("structure-languageSwitcherDefinition")
    ?.addEventListener(
      "change",
      () => changeDefinitionFromHash(getHashFromSelectedLanguage())
    );
}

/**
 * @return {string}
 */
export function getHashFromSelectedLanguage() {
    const languages = document.getElementById("structure-languageSwitcherDefinition");
    if (languages)
    return (
      languages.options[languages.selectedIndex]?.getAttribute("data-attr-hash")
      ?? get('currentHash')
      ?? ''
    );
}

/**
 * able to receive the description from a hash
 * @param hash {string} the destination hash
 * @return {Promise<void>}
 */
export async function changeDefinitionFromHash(hash) {
    const loadedTextByHash = {};
    const application = get('application');
    const route =  imaiosRouting.getFosJsRoutingUrlWithSiteaccess('structure-get-language', {application, hash});
    const storageKey = `${application}:${hash}`;

    try {
        let jsonResponse = {};
        if (typeof loadedTextByHash[storageKey] !== 'undefined') {
            jsonResponse = loadedTextByHash[storageKey];
        }
        else {
            const response = await fetch(route, {
                method: "POST",
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    "Content-type": "application/json; charset=utf-8;"
                }
            });
            jsonResponse = await response.json();
            loadedTextByHash[storageKey] = jsonResponse;
        }


        // todo sanitize HTML !!!
        const definitionElement = document.getElementById("structure-definitionText");
        if (definitionElement) {
            definitionElement.innerHTML = jsonResponse.definition ?? '';
        }

        const sourceElement = document.getElementById("structure-sourceText");
        if (sourceElement) {
            const source = jsonResponse.source ?? '';
            sourceElement.innerHTML = source;
            document
                .getElementById('reference-container')
                .classList.toggle('d-none', source === '');
        }

        const authorElement = document.getElementById("structure-authorText");
        const authorContainer = document.getElementById('author-container');
        if (authorElement) {
            const author = jsonResponse.author ?? ''
            authorElement.innerHTML = author;
            authorContainer.classList.toggle('d-none', author === '');
        }
        applyStructurePreview();
    } catch (err) {
        console.log(err);
        window.NREUM?.notifyError(err);
    }
}

/**
 * able to select on the list the good language associated with the data-attr-hash
 *
 * @param hash {string}
 */
export function selectLanguageFromHash(hash) {
    /**
     * @type {HTMLSelectElement|null}
     */
    const languages = document.getElementById("structure-languageSwitcherDefinition");
    languages.value = Array
      .from(languages)
      .find(option => hash === option.dataset.attrHash)
      ?.value;
}
